/* 16000369221a40555357f02dc234ca405b8b9681
 * This file is automatically generated by graphql-let. */

import * as Types from '../../../../__types__';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FavoriteQueryVariables = Types.Exact<{
  advertId: Types.Scalars['ID'];
}>;


export type FavoriteQuery = { __typename?: 'Query', advert?: { __typename?: 'Advert', id?: string | null, charity?: boolean | null, advertUserstate?: { __typename?: 'AdvertUserstate', id?: string | null, state?: Types.AdvertUserstateState | null } | null, lastUserVisit?: { __typename?: 'AdvertUserVisit', id?: string | null } | null } | null };


export const FavoriteDocument = gql`
    query Favorite($advertId: ID!) {
  advert(id: $advertId) {
    id
    charity
    advertUserstate(state: FAVOURITE) {
      id
      state
    }
    lastUserVisit {
      id
    }
  }
}
    `;

/**
 * __useFavoriteQuery__
 *
 * To run a query within a React component, call `useFavoriteQuery` and pass it any options that fit your needs.
 * When your component renders, `useFavoriteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFavoriteQuery({
 *   variables: {
 *      advertId: // value for 'advertId'
 *   },
 * });
 */
export function useFavoriteQuery(baseOptions: Apollo.QueryHookOptions<FavoriteQuery, FavoriteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FavoriteQuery, FavoriteQueryVariables>(FavoriteDocument, options);
      }
export function useFavoriteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FavoriteQuery, FavoriteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FavoriteQuery, FavoriteQueryVariables>(FavoriteDocument, options);
        }
export type FavoriteQueryHookResult = ReturnType<typeof useFavoriteQuery>;
export type FavoriteLazyQueryHookResult = ReturnType<typeof useFavoriteLazyQuery>;
export type FavoriteQueryResult = Apollo.QueryResult<FavoriteQuery, FavoriteQueryVariables>;